import React, { useState, useEffect } from 'react';
import './TableList.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faPen } from '@fortawesome/free-solid-svg-icons';

export default function Clubs() {
    const [clubs, setClubs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedId, setSelectedId] = useState(null);
    const [showAddModal, setShowAddModal] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [sortBy, setSortBy] = useState('name-az');

    // Fetch clubs list
    const fetchClubs = () => {
        setLoading(true);
        const token = localStorage.getItem('adminToken');

        fetch('https://www.fro.ro/api/admins/clubs.php', {
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(res => res.json())
            .then(data => {
                if (data.clubs) {
                    setClubs(data.clubs);
                } else {
                    setError('Eroare la încărcarea cluburilor');
                }
                setLoading(false);
            })
            .catch(() => {
                setError('Eroare la conexiune');
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchClubs();
    }, []);

    // Delete club
    const handleDelete = (clubId) => {
        if (!window.confirm('Sigur dorești să ștergi acest club?')) return;

        const token = localStorage.getItem('adminToken');
        const backendUrl = 'https://www.fro.ro/api/admins/clubs/delete.php';

        fetch(`${backendUrl}?id=${clubId}`, {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + token,
            }
        })
            .then(res => {
                if (!res.ok) {
                    throw new Error(`HTTP error! status: ${res.status}`);
                }
                return res.json();
            })
            .then(data => {
                if (data.success) {
                    alert('Club șters cu succes!');
                    fetchClubs();
                } else {
                    alert('Eroare la ștergere: ' + data.message);
                }
            })
            .catch(error => {
                alert('Eroare la conexiune: ' + error.message);
            });
    };

    // Edit club
    const handleEdit = (club) => {
        alert('Editează clubul: ' + club.name);
        // Deschide modal/form pentru editare
    };

    const filteredClubs = clubs.filter(c =>
        c.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const sortedClubs = [...filteredClubs].sort((a, b) => {
        if (sortBy === 'name-az') {
            return a.name.localeCompare(b.name);
        } else if (sortBy === 'budget') {
            return (b.budget_allocated || 0) - (a.budget_allocated || 0);
        }
        return 0;
    });

    if (loading) return <p>Se încarcă cluburile...</p>;
    if (error) return <p style={{ color: 'red' }}>{error}</p>;

    return (
        <div className="table-list-container">
            <div className="table-list-header">
                <div className="sort-bar">
                    <label htmlFor="sort-select" className="sort-label">Sort by:</label>
                    <select
                        id="sort-select"
                        className="sort-select"
                        value={sortBy}
                        onChange={e => setSortBy(e.target.value)}
                    >
                        <option value="name-az">A-Z by name</option>
                        <option value="budget">Buget alocat</option>
                    </select>
                </div>
                <input
                    type="text"
                    className="search-bar"
                    placeholder="Search"
                    value={searchTerm}
                    onChange={e => setSearchTerm(e.target.value)}
                />
                <button
                    className="add-circle-btn"
                    onClick={() => setShowAddModal(true)}
                    aria-label="Adaugă club"
                >
                    <span className="plus-icon">+</span>
                </button>
            </div>
            <table className="table-list">
                <thead>
                    <tr>
                        <th></th>
                        <th>Nume club</th>
                        <th>Email</th>
                        <th>Persoană contact</th>
                        <th>Telefon</th>
                        <th>Buget alocat</th>
                        <th>Cheltuit</th>
                        <th>Credit rămas</th>
                        <th>Acțiuni</th>
                    </tr>
                </thead>
                <tbody>
                    {sortedClubs.length === 0 ? (
                        <tr>
                            <td colSpan={9}>Nu există cluburi.</td>
                        </tr>
                    ) : (
                        sortedClubs.map(c => (
                            <tr
                                key={c.id}
                                className={selectedId === c.id ? 'selected' : ''}
                                onClick={() => setSelectedId(c.id)}
                                style={{ cursor: 'pointer' }}
                            >
                                <td>
                                    <input
                                        type="checkbox"
                                        checked={selectedId === c.id}
                                        onChange={() => setSelectedId(c.id)}
                                        onClick={e => e.stopPropagation()}
                                    />
                                </td>
                                <td>{c.name}</td>
                                <td>{c.email}</td>
                                <td>{c.contact_person}</td>
                                <td>{c.phone}</td>
                                <td>{c.budget_allocated}</td>
                                <td>{c.budget_spent}</td>
                                <td>{c.budget_remaining}</td>
                                <td className="table-list-actions">
                                    <button
                                        className="action-btn edit"
                                        title="Editează"
                                        onClick={e => { e.stopPropagation(); handleEdit(c); }}
                                    >
                                        <FontAwesomeIcon icon={faPen} size="lg" color="#222" />
                                    </button>
                                    <button
                                        className="action-btn delete"
                                        title="Șterge"
                                        onClick={e => { e.stopPropagation(); handleDelete(c.id); }}
                                    >
                                        <FontAwesomeIcon icon={faTrash} size="lg" color="#fff" />
                                    </button>
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
            {/* Poți adăuga aici modalul pentru adăugare club */}
            {showAddModal && (
                <div className="modal-bg">
                    <div className="modal-card">
                        <button onClick={() => setShowAddModal(false)}>Închide</button>
                        {/* Form pentru adăugare club */}
                    </div>
                </div>
            )}
        </div>
    );
}
